export default __webpack_public_path__ + "static/blazejd-467673c8b9fddf6ae51d72cebaa4ee98.jpg";